/* Cart "Recommended for you" — self-contained, zero-dependency.
   Curvvvy notes vs the portable spec:
   - money() uses Intl + Shopify.currency.active so EUR/GBP/AUD markets format right
     (the fallback '$X.XX' would lie outside the US).
   - window.fetch is wrapped by the Avalonae bundle app. Harmless in the cart drawer,
     but on product pages with an active bundle widget the wrapper REWRITES /cart/add.js
     into the widget's own bundle selection (verified: quick-add for product A returned
     3x the PDP product). addToCart therefore uses __cvyPureFetch, captured in
     layout/theme.liquid before any app script runs.
   - addToCart asks Shopify for the re-rendered cart-drawer + cart-icon-bubble sections
     in the same round-trip and swaps them in, so the drawer (progress bar, totals,
     shipping row) updates without a reload. */
(function () {
  if (window.__cartRecsInit) return;
  window.__cartRecsInit = true;

  var CART_ADD_URL = '/cart/add.js';

  function money(cents) {
    try {
      var cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD';
      /* Locale must come from the STOREFRONT, not the visitor's browser. Intl with
         `undefined` follows navigator.language, so a zh-CN visitor saw "US$35.90"
         in this sheet while every other price on the page read "$35.90". Same fix
         as VylaStyle (2026-08); ported back here 2026-09-03. */
      var loc = document.documentElement.lang || (window.Shopify && Shopify.locale) || 'en';
      return new Intl.NumberFormat(loc, { style: 'currency', currency: cur }).format(cents / 100);
    } catch (e) { return '$' + (cents / 100).toFixed(2); }
  }
  function sized(url, w) {
    if (!url) return '';
    if (url.indexOf('//') === 0) url = 'https:' + url;
    return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + (w || 400);
  }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; });
  }

  /* shared quick-add sheet */
  var sheet, sheetBody, state = null, cache = {};
  function ensureSheet() {
    if (sheet) return;
    sheet = document.createElement('div');
    sheet.className = 'cart-recs-sheet';
    sheet.hidden = true;
    sheet.innerHTML =
      '<div class="cart-recs-sheet__overlay" data-recs-close></div>' +
      '<div class="cart-recs-sheet__panel" role="dialog" aria-modal="true">' +
        '<button type="button" class="cart-recs-sheet__close" data-recs-close aria-label="Close">&times;</button>' +
        '<div class="cart-recs-sheet__body"></div></div>';
    document.body.appendChild(sheet);
    sheetBody = sheet.querySelector('.cart-recs-sheet__body');
    sheet.addEventListener('click', function (e) { if (e.target.closest('[data-recs-close]')) closeSheet(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !sheet.hidden) closeSheet(); });
  }
  /* rAF is throttled to zero in hidden/background tabs, which would leave the panel
     translated off-screen — the timeout guarantees the open class lands either way. */
  function openSheet() { ensureSheet(); sheet.hidden = false; requestAnimationFrame(function () { sheet.classList.add('is-open'); }); setTimeout(function () { sheet.classList.add('is-open'); }, 80); document.documentElement.style.overflow = 'hidden'; }
  function closeSheet() { if (!sheet) return; sheet.classList.remove('is-open'); document.documentElement.style.overflow = ''; setTimeout(function () { sheet.hidden = true; sheetBody.innerHTML = ''; }, 280); }

  function optionGroups(p) {
    return (p.options || []).map(function (o, i) {
      var name = (typeof o === 'string') ? o : (o.name || ('Option ' + (i + 1)));
      var set = [];
      p.variants.forEach(function (v) { var val = v.options[i]; if (val && set.indexOf(val) === -1) set.push(val); });
      return { name: name, position: i, values: set };
    });
  }
  function findVariant(p, sel) { return p.variants.find(function (v) { return v.options.every(function (val, i) { return sel[i] === val; }); }); }
  /* Per-colour image groups: each colour variant's featured_media.position marks where
     that colour's photo block starts in media[]; bucket every image under the last mark
     it passed (TexTale spec §3b). Needs no manual tagging. */
  function buildColorImages(p, colorPos) {
    if (colorPos < 0 || !p.media || !p.media.length) return null;
    var marks = [], seen = {};
    p.variants.forEach(function (v) {
      var c = v.options[colorPos], pos = v.featured_media && v.featured_media.position;
      if (c != null && pos && !seen[c]) { seen[c] = 1; marks.push({ color: c, pos: pos }); }
    });
    if (!marks.length) return null;
    marks.sort(function (a, b) { return a.pos - b.pos; });
    var groups = {};
    p.media.forEach(function (m) {
      if (m.media_type && m.media_type !== 'image') return;
      var cur = marks[0].color;
      for (var i = 0; i < marks.length; i++) { if (m.position >= marks[i].pos) cur = marks[i].color; else break; }
      (groups[cur] = groups[cur] || []).push(m.src);
    });
    return groups;
  }
  function galleryFor(p, color) {
    var srcs = (state && state.colorImages && color != null && state.colorImages[color] && state.colorImages[color].length)
      ? state.colorImages[color]
      : ((p.images && p.images.length) ? p.images : (p.featured_image ? [p.featured_image] : []));
    return srcs.map(function (src) { return '<div class="cart-recs-sheet__slide"><img src="' + sized(src, 640) + '" alt="" loading="lazy"></div>'; }).join('');
  }
  function setGallery(color) { var g = sheetBody.querySelector('.cart-recs-sheet__gallery'); if (g) { g.innerHTML = galleryFor(state.product, color); g.scrollLeft = 0; } }
  function valueAvailable(p, pos, value, sel) {
    return p.variants.some(function (v) {
      if (v.options[pos] !== value) return false;
      return Object.keys(sel).every(function (k) { k = +k; if (k === pos) return true; return sel[k] == null || v.options[k] === sel[k]; }) && v.available;
    });
  }

  function renderSheet(p) {
    state = { product: p, selected: {}, variant: null, colorPos: -1, colorImages: null };
    var single = p.variants.length === 1;
    var ogs = optionGroups(p);
    if (!single) state.colorPos = ogs.findIndex(function (o) { return /colou?r/i.test(o.name); });
    state.colorImages = buildColorImages(p, state.colorPos);
    /* colour preselected (TexTale behaviour) so the gallery is meaningful on open;
       size stays unpicked so the add button still forces an explicit choice */
    var initColor = (state.colorPos > -1 && ogs[state.colorPos].values.length) ? ogs[state.colorPos].values[0] : null;
    if (initColor != null) state.selected[state.colorPos] = initColor;
    var h = '';
    h += '<div class="cart-recs-sheet__gallery">' + galleryFor(p, initColor) + '</div>';
    h += '<div class="cart-recs-sheet__info">';
    h += '<p class="cart-recs-sheet__name">' + esc(p.title) + '</p>';
    h += '<p class="cart-recs-sheet__price" data-recs-price>' + money(p.price) + '</p>';
    if (!single) ogs.forEach(function (opt) {
      var isColor = opt.position === state.colorPos;
      h += '<div class="cart-recs-sheet__opt"><span class="cart-recs-sheet__optname">' + esc(opt.name)
         + (isColor ? ' — <b data-recs-colorname>' + esc(initColor || '') + '</b>' : '') + '</span><div class="cart-recs-sheet__vals">';
      opt.values.forEach(function (val) {
        var pressed = (state.selected[opt.position] === val) ? 'true' : 'false';
        var thumb = isColor && state.colorImages && state.colorImages[val] && state.colorImages[val][0];
        if (thumb) {
          h += '<button type="button" class="cart-recs-sheet__val cart-recs-sheet__swatch" data-pos="' + opt.position + '" data-val="' + esc(val) + '" title="' + esc(val) + '" aria-pressed="' + pressed + '" style="background-image:url(\'' + sized(thumb, 96) + '\')"></button>';
        } else {
          h += '<button type="button" class="cart-recs-sheet__val" data-pos="' + opt.position + '" data-val="' + esc(val) + '" aria-pressed="' + pressed + '">' + esc(val) + '</button>';
        }
      });
      h += '</div></div>';
    });
    h += '<div class="cart-recs-sheet__addrow"><button type="button" class="cart-recs-sheet__add"' + (single ? '' : ' disabled') + '>' + (single ? 'Add to cart' : 'Select options') + '</button></div>';
    h += '<a class="cart-recs-sheet__link" href="/products/' + esc(p.handle) + '">View full details</a></div>';
    sheetBody.innerHTML = h;
    if (single) state.variant = p.variants[0];
    bindSheet();
    if (initColor != null) refreshSheet();
  }
  function refreshSheet() {
    var p = state.product;
    sheetBody.querySelectorAll('.cart-recs-sheet__val').forEach(function (b) { b.dataset.soldout = valueAvailable(p, +b.dataset.pos, b.dataset.val, state.selected) ? 'false' : 'true'; });
    var all = (p.options || []).every(function (o, i) { return state.selected[i] != null; });
    var add = sheetBody.querySelector('.cart-recs-sheet__add');
    if (all) { var v = findVariant(p, state.selected); state.variant = v;
      if (v && v.available) { add.disabled = false; add.textContent = 'Add to cart'; sheetBody.querySelector('[data-recs-price]').textContent = money(v.price); }
      else { add.disabled = true; add.textContent = 'Sold out'; }
    } else { add.disabled = true; add.textContent = 'Select options'; }
  }
  function bindSheet() {
    sheetBody.querySelectorAll('.cart-recs-sheet__val').forEach(function (b) {
      b.addEventListener('click', function () {
        if (b.dataset.soldout === 'true') return;
        var pos = +b.dataset.pos; state.selected[pos] = b.dataset.val;
        sheetBody.querySelectorAll('.cart-recs-sheet__val[data-pos="' + pos + '"]').forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
        if (pos === state.colorPos) {
          setGallery(b.dataset.val);
          var cn = sheetBody.querySelector('[data-recs-colorname]');
          if (cn) cn.textContent = b.dataset.val;
        }
        refreshSheet();
      });
    });
    var add = sheetBody.querySelector('.cart-recs-sheet__add');
    add.addEventListener('click', function () {
      if (add.disabled || !state.variant) return;
      add.disabled = true; add.textContent = 'Adding…';
      addToCart(state.variant.id).then(closeSheet).catch(function () { add.disabled = false; add.textContent = 'Try again'; });
    });
  }
  function quickAdd(handle) {
    openSheet();
    sheetBody.innerHTML = '<p class="cart-recs-sheet__loading">Loading…</p>';
    if (cache[handle]) { renderSheet(cache[handle]); return; }
    fetch('/products/' + handle + '.js').then(function (r) { return r.json(); })
      .then(function (p) { cache[handle] = p; renderSheet(p); })
      .catch(function () { sheetBody.innerHTML = '<p class="cart-recs-sheet__loading"><a href="/products/' + esc(handle) + '">View product</a></p>'; });
  }

  /* swap in the re-rendered drawer + header bubble Shopify returns with the add */
  function applySections(sections) {
    if (!sections) return;
    if (sections['cart-drawer']) {
      var doc = new DOMParser().parseFromString(sections['cart-drawer'], 'text/html');
      var src = doc.querySelector('#CartDrawer');
      var dst = document.querySelector('#CartDrawer');
      if (src && dst) dst.innerHTML = src.innerHTML;
    }
    if (sections['cart-icon-bubble']) {
      var bub = document.querySelector('#shopify-section-cart-icon-bubble');
      if (bub) bub.innerHTML = sections['cart-icon-bubble'];
    }
  }
  function addToCart(id) {
    var pureFetch = window.__cvyPureFetch || window.fetch;
    return pureFetch(CART_ADD_URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: id, quantity: 1 }], sections: 'cart-drawer,cart-icon-bubble', sections_url: window.location.pathname })
    })
      .then(function (r) { return r.json().then(function (d) { if (!r.ok) throw new Error(d.description || 'error'); return d; }); })
      .then(function (data) {
        applySections(data.sections);
        var drawer = document.querySelector('cart-drawer');
        if (drawer && typeof drawer.open === 'function') drawer.open();
        document.dispatchEvent(new CustomEvent('cart-recs:added', { bubbles: true, detail: { item: data } }));
        return data;
      });
  }

  class CartRecs extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.cart-recs__track');
      this.prevBtn = this.querySelector('[data-recs-prev]');
      this.nextBtn = this.querySelector('[data-recs-next]');
      if (this.prevBtn) this.prevBtn.addEventListener('click', this.page.bind(this, -1));
      if (this.nextBtn) this.nextBtn.addEventListener('click', this.page.bind(this, 1));
      if (this.track) this.track.addEventListener('scroll', this.updateArrows.bind(this), { passive: true });
      this.addEventListener('click', function (e) { var b = e.target.closest('[data-recs-handle]'); if (!b) return; e.preventDefault(); quickAdd(b.getAttribute('data-recs-handle')); });
      this.load();
    }
    load() {
      var pid = this.getAttribute('data-product-id');
      var limit = this.getAttribute('data-limit') || 8;
      var endpoint = this.getAttribute('data-endpoint') || 'cart-recs-list';
      if (!pid) { this.hidden = true; return; }
      var url = '/recommendations/products?section_id=' + encodeURIComponent(endpoint) + '&limit=' + encodeURIComponent(limit) + '&product_id=' + encodeURIComponent(pid);
      var self = this;
      fetch(url).then(function (r) { return r.text(); }).then(function (html) {
        var tmp = document.createElement('div'); tmp.innerHTML = html;
        var list = tmp.querySelector('[data-recs-list]');
        if (list && list.children.length && self.track) { self.track.innerHTML = list.innerHTML; self.hidden = false; self.updateArrows(); }
        else { self.hidden = true; }
      }).catch(function () { self.hidden = true; });
    }
    page(dir) {
      if (!this.track) return;
      var card = this.track.querySelector('.cart-recs__card'); var gap = 16;
      var step = card ? (card.getBoundingClientRect().width + gap) * 2 : this.track.clientWidth * 0.85;
      this.track.scrollBy({ left: dir * step, behavior: 'smooth' });
    }
    updateArrows() {
      if (!this.track || !this.prevBtn || !this.nextBtn) return;
      var max = this.track.scrollWidth - this.track.clientWidth - 2;
      this.prevBtn.disabled = this.track.scrollLeft <= 2;
      this.nextBtn.disabled = this.track.scrollLeft >= max;
    }
  }
  if (!customElements.get('cart-recommended-for-you')) customElements.define('cart-recommended-for-you', CartRecs);
})();
